import { TicketWithDetailsDto } from '@sib/api';
import { Avatar } from '@spendbrain/common/components/Avatar';
import { useAppTranslation } from '@spendbrain/modules/tickets/hooks';
import { TicketDetailWrapper } from '../TicketDetailWrapper';

interface TicketDescriptionSectionProps {
  ticket?: TicketWithDetailsDto;
}

export const TicketDescriptionSection = ({
  ticket,
}: TicketDescriptionSectionProps) => {
  const { t } = useAppTranslation();

  const isAssigneDataAvailable =
    ticket?.assignee &&
    (ticket?.assignee?.name?.trim() || ticket?.assignee?.email?.trim());

  return (
    <div className="flex justify-between gap-3">
      <TicketDetailWrapper
        label={t('components.ticketDetails.description.description')}
        className="w-1/2 break-all"
      >
        {ticket?.description || <p className="text-xs">{t('noData')}</p>}
      </TicketDetailWrapper>
      <TicketDetailWrapper
        label={t('components.ticketDetails.description.assignedTo')}
        className="w-1/2"
      >
        {isAssigneDataAvailable ? (
          <div className="flex items-center gap-2 text-sm font-medium">
            {(ticket?.assignee?.avatarUrl || ticket?.assignee?.name) && (
              <Avatar
                avatarFallbackProps={{
                  name: ticket?.assignee?.name,
                  className: 'bg-muted text-sm',
                }}
                avatarImageProps={{
                  avatarUrl: ticket?.assignee?.avatarUrl,
                }}
                className="size-12 self-start border-4 border-white bg-white shadow-md"
              />
            )}
            <div className="flex max-h-full flex-col gap-1 text-sm break-words">
              <p className="leading-none font-medium">
                {ticket?.assignee?.name}
              </p>
              <p className="leading-none font-normal break-all">
                {ticket?.assignee?.email}
              </p>
            </div>
          </div>
        ) : (
          <p className="text-xs">{t('noData')}</p>
        )}
      </TicketDetailWrapper>
    </div>
  );
};
